import React  from "react";
import { useParams } from 'react-router-dom';
import SalaryForm from "./components/SalaryForm";
import Card from "components/card";

const EditEmployeeSalary = () => {

	const { employeeId, salaryId } = useParams();

	return (
	    <div>
			<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
					<SalaryForm employeeId={employeeId} recordId={salaryId} mode="edit"/>
				</div>
			</Card>
	    </div>
    );
};

export default EditEmployeeSalary;